import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FilterValueInput } from './FilterValueInput';
import { ActiveFilter, FilterValue } from '@/types/filterBuilder';

interface ActiveFilterChipProps {
  filter: ActiveFilter;
  onChange: (value: FilterValue) => void;
  onRemove: () => void;
}

export function ActiveFilterChip({
  filter,
  onChange,
  onRemove,
}: ActiveFilterChipProps) {
  const { meta, value } = filter;

  return (
    <div className="flex items-center gap-2 bg-muted/50 border rounded-lg px-3 py-2">
      <span className="text-sm font-medium text-foreground whitespace-nowrap">
        {meta.label}:
      </span>
      <div className="flex-1">
        <FilterValueInput
          field={meta}
          value={value}
          onChange={onChange}
          compact
        />
      </div>
      <Button
        variant="ghost"
        size="sm"
        className="h-6 w-6 p-0 hover:bg-destructive/10 hover:text-destructive"
        onClick={onRemove}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}

export default ActiveFilterChip;
